import { useTranslation, withTranslation } from 'react-i18next';
import { Typography, Box, InputLabel, FormControl } from '@material-ui/core';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import { getLocalDateFormat } from '../../../../../utils/common';
import MaskedInput from './MaskedInput.jsx';

const useStyles = makeStyles((theme) => ({
  'field__input--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  dateOfBirthField: {
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: '15px',
    color: theme.palette.custom?.lightBlack,
    '&.MuiInputBase-root': {
      '&.Mui-focused': {
        boxShadow: '0 0 10px #9ecaed',
      },
    },
  },
  dataOfBirthFieldBorder: {
    border: `solid 1px ${theme.palette.custom?.lightBlack}`,
  },
  errorMessage: {
    fontFamily: 'Formula1-Regular',
    fontSize: '12px',
    letterSpacing: '.5px',
    fontWeight: 500,
  },
}));

function DateOfBirthField(props) {
  const {
    form = {},
    name,
    autoFocusRef,
    customClasses,
    resetFormStatus = false,
    resetFormHandler,
  } = props;
  const { values = {} } = form;
  const { t } = useTranslation();
  const classes = useStyles();

  const dateFormatPlaceHolder = `(${getLocalDateFormat()})`;

  return (
    <Box
      className={`field field--${name} ${
        customClasses && customClasses.fieldWidth
      }`}
      mb={4}
    >
      <InputLabel>
        <Typography
          variant="body1"
          color="textPrimary"
          className={customClasses && customClasses.titilliumFont}
        >
          {name === 'BirthDate'
            ? t(LocaleKeys.accountInfo.dateOfBirth)
            : t(LocaleKeys.registration.dateOfBirth)}
        </Typography>
      </InputLabel>
      <FormControl
        className={`field__form-control ${
          customClasses && customClasses.fieldHeight
        }`}
      >
        <MaskedInput
          value={values[name] || ''}
          onChange={(e) => {
            if (resetFormStatus) {
              resetFormHandler();
            }
            form.handleChange(e);
          }}
          name={name}
          placeholder={dateFormatPlaceHolder}
          form={form}
          classes={classes}
          autoFocusRef={autoFocusRef}
        />
      </FormControl>
      {form?.errors?.[name] ? (
        <Box ml={3} mt={2} className={`field__errorBox`}>
          <Typography
            variant="body2"
            color="error"
            className={classes.errorMessage}
          >
            {form.errors[name]}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default compose(withTranslation())(DateOfBirthField);
